import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import { format } from 'date-fns';

export default function ChatPanel({ match, onClose }) {
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    api.get(`/matches/${match.id}/messages`)
      .then(r => setMessages(r.data))
      .finally(() => setLoading(false));
  }, [match.id]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    const content = text;
    setText('');
    try {
      const res = await api.post(`/matches/${match.id}/messages`, { content });
      setMessages(prev => [...prev, { ...res.data, sender_name: user.name }]);
    } catch {
      setText(content);
    }
  };

  return (
    <div className="chat-panel-overlay" style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200,
      display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end',
      padding: 24
    }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="card chat-panel-card" style={{
        width: '100%', maxWidth: 420, height: 560, display: 'flex', flexDirection: 'column',
        animation: 'fadeUp 0.2s ease'
      }}>
        {/* Header */}
        <div style={{
          padding: '16px 20px', borderBottom: '1px solid var(--border)',
          display: 'flex', alignItems: 'center', gap: 12
        }}>
          <div style={{ display: 'flex' }}>
            {(match.participants || []).map((p, i) => (
              <div key={p.id} className="avatar" style={{
                background: p.color,
                marginLeft: i > 0 ? -10 : 0,
                border: '2px solid white',
                zIndex: (match.participants.length - i)
              }}>
                {p.name[0]}
              </div>
            ))}
          </div>
          <div>
            <div style={{ fontWeight: 600 }}>
              {(match.participants || []).map(p => p.name.split(' ')[0]).join(', ')}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Lunch match 🍵</div>
          </div>
          <button
            className="btn btn-ghost"
            style={{ marginLeft: 'auto', padding: '6px 10px' }}
            onClick={onClose}
          >✕</button>
        </div>

        {/* Messages */}
        <div style={{ flex: 1, overflow: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {loading ? (
            <div style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 40 }}>Loading...</div>
          ) : messages.length === 0 ? (
            <div style={{ textAlign: 'center', color: 'var(--text-muted)', marginTop: 40 }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>👋</div>
              <p>Say hi to {(match.participants || []).map(p => p.name.split(' ')[0]).join(' & ')}!</p>
            </div>
          ) : (
            messages.map(msg => {
              const mine = msg.sender_id === user.id;
              return (
                <div key={msg.id} style={{ display: 'flex', justifyContent: mine ? 'flex-end' : 'flex-start' }}>
                  <div>
                    <div className={`message-bubble ${mine ? 'mine' : 'theirs'}`}>{msg.content}</div>
                    <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 3, textAlign: mine ? 'right' : 'left' }}>
                      {format(new Date(msg.created_at), 'h:mm a')}
                    </div>
                  </div>
                </div>
              );
            })
          )}
          <div ref={bottomRef} />
        </div>

        {/* Input */}
        <form onSubmit={send} style={{
          padding: '12px 16px', borderTop: '1px solid var(--border)',
          display: 'flex', gap: 8
        }}>
          <input
            className="input"
            placeholder="Type a message..."
            value={text}
            onChange={e => setText(e.target.value)}
            style={{ flex: 1 }}
          />
          <button type="submit" className="btn btn-primary" style={{ padding: '10px 16px' }}>
            Send
          </button>
        </form>
      </div>
    </div>
  );
}
